import { render, staticRenderFns } from "./SingleUser.vue?vue&type=template&id=b9ff7ce6&scoped=true&"
import script from "./SingleUser.vue?vue&type=script&lang=js&"
export * from "./SingleUser.vue?vue&type=script&lang=js&"
import style0 from "./SingleUser.vue?vue&type=style&index=0&id=b9ff7ce6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ff7ce6",
  null
  
)

export default component.exports